<template>
  <window
    ref="window"
    size="lg"
    title="Abwesenheit eintragen"
    iconitem='<svg width="1.2em" height="1.2em" viewBox="0 0 16 16" class="bi bi-calendar3 mr-2" fill="#51B67E" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"/>
  <path fill-rule="evenodd" d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
</svg>'
  >
    {{ checkIfEdit }}
    <editable
      :show-toggle-button="false"
      save-url=""
      class="mt-mdsm"
      default-state="edit"
    >
      <template slot-scope="editable">
        <div class="container container-xxs mt-mdsm">
          <select
            style="height: 40px; margin-bottom: 15px"
            class="w-100"
            v-model="reason_id"
          >
            <option
              v-for="item in reasons"
              :value="item.id"
              v-bind:key="item.id"
            >
              {{ item.reason }}
            </option>
          </select>
          <h3>Zeitpunkt wählen</h3>
          <div class="row">
            <div class="col col-6">
              <editable-date
                name="start[date]"
                :popover-options="{ visibility: 'focus' }"
                :value="startDate"
                @setDate="changeStartDate"
                label="Datum Beginn"
              >
                <!-- @user-input="changeStartDate" -->
              </editable-date>
            </div>
            <div class="col col-6">
              <editable-date
                name="end[date]"
                :popover-options="{ visibility: 'focus' }"
                :value="endDate"
                label="Datum Ende"
                @setDate="changeEndDate"
              >
                <!-- @user-input="changeEndDate" -->
              </editable-date>
            </div>
          </div>
          <div class="row">
            <div class="col col-6">
              <editable-time
                name="start[time]"
                :value="startTime"
                @user-input="changeStartTime"
                :disabledTime="checkboxDate"
                label="Zeit Beginn"
              >
              </editable-time>
            </div>
            <div class="col col-6">
              <editable-time
                name="end[time]"
                :value="endTime"
                @user-input="changeEndTime"
                label="Zeit Ende"
                :disabledTime="checkboxDate"
              >
              </editable-time>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <img
              :src="
                icon(
                  checkboxDate
                    ? 'checkbox-checked.svg'
                    : 'checkbox-unchecked.svg'
                )
              "
              class="mr-1"
              @click="toggleCheckDate()"
            />
            <label class="m-0" for="checkbox">Ganzer Tag?</label>
          </div>
        </div>

        <div class="container-fluid">
          <div class="row">
            <div class="col buttons">
              <button
                type="button"
                class="btn btn-secondary"
                @click="closeWindow('close')"
              >
                {{ __("main.buttons.cancel") }}
              </button>
              <button
                v-if="editBreak"
                type="button"
                class="btn btn-secondary"
                @click="deleteBreak()"
              >
                {{ __("main.buttons.delete") }}
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click="checkValue()"
              >
                {{ __("main.buttons.confirm") }}
              </button>
            </div>
          </div>
        </div>
      </template>
    </editable>
  </window>
</template>

<script>
import api from "../helper/api";

export default {
  provide: {
    windowId: "calendarBreak",
  },
  props: {
    break_edit: {
      type: Object,
    },
  },
  computed: {
    checkIfEdit() {
      if (this.break_edit) {
        this.editBreakCalendar();
      } else {
        this.editBreak = false;
        this.clearData();
      }
    },
  },

  created() {
    if (this.break_edit) {
      this.editBreakCalendar();
    }
    this.getReason();
    this.setDefaultDate();
  },
  data() {
    return {
      dateNow: null,
      startDate: null,
      endDate: null,
      startTime: null,
      endTime: null,
      titleBreak: "",
      reason_id: 0,
      reasons: [],
      editBreak: false,
      checkboxDate: false,
    };
  },
  methods: {
    toggleCheckDate() {
      this.checkboxDate = !this.checkboxDate;
    },
    changeEndTime($event) {
      let time = $event.data.time;
      if (!this.editBreak) {
        time = time.HH + ":" + time.mm;
      }
      var isValid = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/.test(time);
      if (isValid) {
        this.endTime = time;
      }
    },
    changeStartTime($event) {
      let time = $event.data.time;
      if (!this.editBreak) {
        time = time.HH + ":" + time.mm;
      }
      var isValid = /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/.test(time);
      if (isValid) {
        this.startTime = time;
      }
    },
    changeStartDate(date) {
      this.startDate = date;
    },
    changeEndDate(date) {
      this.endDate = date;
    },
    getStartEndDayTime() {
      this.startTime = "00:00";
      this.endTime = "23:59";
    },
    setDefaultDate() {
      var d = new Date();
      if (!this.editBreak) {
        this.startDate = d;
        this.endDate = d;
      }
    },
    async checkValue() {
      if (this.checkboxDate) {
        this.getStartEndDayTime();
      }
      //Start date
      let start = new Date(this.startDate);
      let time = this.startTime.split(":");
      if (time.length > 1) {
        start.setHours(time[0], time[1], 0);
      }

      //End date
      let end = new Date(this.endDate);
      let endtime = this.endTime.split(":");
      if (endtime.length > 1) {
        end.setHours(endtime[0], endtime[1], 0);
      }

      let data = {
        start: start,
        end: end,
        reason_id: this.reason_id,
      };
      let url = "break";
      if (this.editBreak) {
        url = url + "/" + this.break_edit.id;
      }

      const response = this.save(url, data);
    },

    save(url, data) {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch(
            "tasks/runUnique",
            this.api
              .post(url, data, true)
              .name("addBreak")
              .data({ view: "Calendar" })
          )
          // on deferred: resolve save processor and return input data for next then
          .deferred(() => {
            // disallow updating user data from source until task is executed
            // this.$store.commit("user/disallowUpdateFromSource");
            // // add deferred warning to profile alerts
            // this.$store.commit("alerts/break", [
            //   {
            //     type: "warning",
            //     text: this.__("main.common.messages.save_deferred"),
            //   },
            // ]);
            // resolve save processor with empty object
            resolve({});

            return data;
          })
          // always commit update to store on resolve
          // .thenAlways(["store", "commit:user/updateProfile"])
          // on non-deferred resolve: resolve save processor and redirect if user has been forced to edit his profile
          .then((apiResponse) => {
            this.closeWindow();
            resolve({}); // resolve save with empty response data because updated data will come from the store

            return apiResponse;
          })
          // on deferred resolve: clear profile alerts
          // .thenDeferred(["store", "commit:alerts/profile", null])
          // on non-deferred reject: reject save processor with raw response object
          .catch((apiResponse) => {
            if (apiResponse.networkError) {
              reject(apiResponse.message);
            } else {
              resolve(apiResponse.rawResponse);
            }
          });
        // on deferred reject commit alerts to store
        // .catch(["store", "commit:alerts/profile"])
        // after deferred: allow updating user data from source again
        // .finallyDeferred(["store", "commit:user/allowUpdateFromSource"]);
      });
    },

    async deleteBreak() {
      let url = "break/" + this.break_edit.id;
      const response = await this.api.delete(url, {}).run();
      if (response.status == 200) {
        this.closeWindow();
        // location.reload();
      }
    },

    editBreakCalendar() {
      this.editBreak = true;
      this.reason_id = this.break_edit.reason_id;
      let start = this.break_edit.start;
      let end = this.break_edit.end;
      this.startDate = new Date(start);
      this.endDate = new Date(this.break_edit.end);
      if (start.length > 11) {
        this.startTime = start.substring(11);
      }
      if (end.length > 11) {
        this.endTime = end.substring(11);
      }
    },
    async getReason() {
      const response = await this.api.get("reason/rejected").run();
      this.reasons = response.data;
      if (this.reasons.length > 0 && !this.editBreak) {
        this.reason_id = this.reasons[0].id;
      }
    },
    closeWindow(item = "update") {
      this.$refs.window.hide(item);
      this.clearData();
    },
    clearData() {
      this.setDefaultDate();
      this.startTime = null;
      this.endTime = null;
    },
  },
};
</script>
